import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class Notification extends Entity<Notification> {
    @Expose()
    label!: string
}
